import PropTypes from 'prop-types';
import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from "react-bootstrap/lib/Col";

import config from '../../config';
import t from '../../lib/I18n';
import SmartcardRegistration from '../../records/customer/SmartcardRegistration';
import User from '../../records/User';
import CustomerRegistration from '../../records/customer/Registration';

import SmartcardNumberHelp from "../../../delay-repay/src/components/delayRepay/SmartcardNumberHelp";
import AgeCheckbox from '../customer/marketingPrefs/AgeCheckbox';
import FormComponent from '../form/FormComponent';
import PostalAddress from '../customer/PostalAddress';
import PhotoUpload from '../general/PhotoUpload';
import DateOfBirth from '../customer/DateOfBirth';
import HelpIcon from "../general/HelpIcon";
import Isrn from '../customer/Isrn';
import FormError from '../form/Error';

class SmartcardRegistrationForm extends FormComponent {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        smartcard: PropTypes.instanceOf(SmartcardRegistration).isRequired,
        submitted: PropTypes.bool,
        smartcardSubmitted: PropTypes.bool,
        user: PropTypes.oneOfType([
            PropTypes.instanceOf(User),
            PropTypes.instanceOf(CustomerRegistration)
        ]),
        badPostcode: PropTypes.string,
        allowPhotoUpload: PropTypes.bool,
        onSelectAddress: PropTypes.func.isRequired,
        onAgeToggle: PropTypes.func,
        outsideLabel: PropTypes.bool
    };

    static defaultProps = {
        allowPhotoUpload: true,
        badPostcode: null,
        submitted: false,
        smartcardSubmitted: false,
        outsideLabel: true
    };

    _handleToggleAge = () => {
        const { onAgeToggle, smartcard, user } = this.props;
        const isOver16 = smartcard.get('isOver16');
        let preferences = user.get('preferences');
        if (isOver16) {
            preferences = preferences.resetAllDisabledMarketingFields();
        }
        onAgeToggle(!isOver16, preferences);
    };

    render () {
        const { smartcard, onChange, submitted, smartcardSubmitted, badPostcode, allowPhotoUpload, onSelectAddress, outsideLabel, user } = this.props;

        const isOver16 = smartcard.get('isOver16');

        const validation = smartcard.getValidationSummary();

        if (badPostcode && badPostcode === smartcard.postcode) {
            validation.postcode = t('alertmessage.badPostCode');
        }

        const sharedProps = {
            onChange,
            form: smartcard,
            validation: validation,
            visited: submitted,
            onSelectAddress
        };

        const photoUploadProps = {
            acceptedFormats: config.get('smartcardPhotoMimeTypes'),
            bodyText: t('account.smartcardsignup.children'),
            footerTextFeatureFlag: "enableChildSmartcardMessage",
            footerText: t('account.smartcardsignup.children.requirements', { brand: t('app.owner.short') }),
            placeholderIcon: 'smiley',
            uploadConditions: [
                t('account.smartcardsignup.children.condition1'),
            ]
        };

        return (
            <div>
                <form ref={ this.captureFormRef } className="register-smartcard" data-test-id="apply-smartcard-form-root">
                    <Row>
                        <PostalAddress
                            outsideLabel={ outsideLabel }
                            alwaysShowAddressFields={ smartcardSubmitted }
                            label={ t('account.smartcardsignup.address') }
                            { ...sharedProps } />
                    </Row>

                    {!user.created &&
                        <Row>
                            <Col md={12}>
                                <AgeCheckbox
                                    isOver16={ isOver16 }
                                    onToggle={this._handleToggleAge} />
                            </Col>
                        </Row>
                    }

                    {!isOver16 &&
                        <Row>
                            <DateOfBirth
                                field="dateOfBirth"
                                outsideLabel={ outsideLabel }
                                label={ t('account.smartcardsignup.dob') }
                                customValidationMessage={ validation.isOver16 }
                                { ...sharedProps }
                            />
                        </Row>
                    }

                    { !smartcard.selfRegistered && allowPhotoUpload && smartcard.requiresPhotograph() &&
                        <PhotoUpload field="photo" { ...sharedProps } { ...photoUploadProps } />
                    }

                    { smartcard.selfRegistered &&
                        <Row>
                            <Col xs={ 12 }>
                                <p className="label">{ t('account.smartcard.text.label') }</p>
                                <HelpIcon
                                    heading="delayrepay.help.smartcardNumber.title"
                                    body={ <SmartcardNumberHelp /> }
                                />
                            </Col>
                            <Isrn
                                field="isrn"
                                label={ t('account.smartcard.text.label') }
                                { ...sharedProps }
                            />
                        </Row>
                    }

                    { validation.isEnabledSmartcardRegistration && <FormError message={validation.isEnabledSmartcardRegistration}/> }
                </form>
            </div>
        );
    }
}

export default SmartcardRegistrationForm;
